import React from 'react'
import PropTypes from 'prop-types'

import Box from 'suitTheme/Box'
import Image from 'suitTheme/Image'

const UserProfileImage = (props) => {
  const {
    boxProps, children, circle, image, imageKey, width, height,
  } = props

  const imageUrl = image ? image[imageKey || 'thumb_url'] : null

  return (
    <Image
      boxProps={{ backgroundColor: 'hoverLightGrey', fontSize: 'small', ...boxProps }}
      circle={circle}
      height={height || 30}
      width={width || 30}
      url={imageUrl}
    >
      <Box color="bodyFontColor" width="auto">
        {!imageUrl && children}
      </Box>
    </Image>
  )
}

UserProfileImage.propTypes = {
  boxProps: PropTypes.object,
  children: PropTypes.node,
  circle: PropTypes.bool,
  height: PropTypes.number,
  image: PropTypes.object,
  imageKey: PropTypes.string,
  width: PropTypes.number,
}

UserProfileImage.defaultProps = {
  circle: true,
}

export default UserProfileImage
